import axios from 'axios';
const HTTP = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL
});

HTTP.interceptors.request.use(
    (config) => {
        let token = localStorage.getItem('wwp-token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${ token }`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default HTTP;